/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butstatus1Inputs */

const de__field_butstatus1 = /** @type {(inputs: _Field_Butstatus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT Status`)
};

/**

* @param {_Field_Butstatus1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butstatus1 = /** @type {((inputs?: _Field_Butstatus1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butstatus1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butstatus1(inputs)
});
export { _field_butstatus1 as "_field_butStatus" }